export default function checkLuhnAlgorithm(cardNumber) {
  let s = 0;
  let doubleDigit = false;

  // eslint-disable-next-line no-plusplus
  for (let i = cardNumber.length - 1; i >= 0; i--) {
    let digit = +cardNumber[i];
    if (doubleDigit) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    s += digit;
    doubleDigit = !doubleDigit;
  }

  return s % 10 === 0;
}
